import React from 'react';
import { View, Text, Image, ScrollView, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import { inlineStyleSeparator } from './InlineStyleSeparator'

export const RenderBlocks = ({ blocks, style, textStyle={fontSize: 14, color: 'black'} }) => {
	if (blocks.length === 0) return null;

	const combinedTextStyle = Array.isArray(textStyle) ? Object.assign(...textStyle) : textStyle;

	return (
		<ScrollView style={style}>
			{
				blocks.map((item, index, array) => {
					switch (item.type) {

						case 'unstyled':
							return <StyledText
								key={item.key}
								text={item.text}
								ranges={item.inlineStyleRanges}
								textStyle={combinedTextStyle}
							/>

						case 'header-one':
							return <Header
								key={item.key}
								text={item.text}
								ranges={item.inlineStyleRanges}
								textStyle={combinedTextStyle}
							/>

						case 'unordered-list-item':
							const isFirst = (index !== 0 && array[index - 1].type !== 'unordered-list-item');
							const isLast = (index !== array.length -1 && array[index + 1].type !== 'unordered-list-item');

							return <Bullet
								key={item.key}
								text={item.text}
								ranges={item.inlineStyleRanges}
								style={{marginTop: isFirst ? 18 : null, marginBottom: isLast ? 18 : null}}
								textStyle={combinedTextStyle}
							/>

						case 'atomic':
							return <Image
								key={item.key}
								source={{ uri: `data:image/jpeg;base64,${item.text}` }}
								resizeMode='contain'
								style={{ height: 400, width: 600, maxWidth: 600, alignSelf: 'center', aspectRatio: 16/9  }}
							/>
						default:
							return <Text key={item.key} style={combinedTextStyle}>{'ERROR: Missing block'}</Text>
					}
				})
			}
		</ScrollView>
	)
}

const StyledText = ({text, ranges, textStyle}) => {
	if (ranges.length === 0) return <Text style={textStyle}>{ text }</Text>

	const segments = inlineStyleSeparator(text, ranges);

	return(
		<Text style={textStyle}>
			{
				segments.map(item => {
					const [ bold, italic, underline ] = [1, 2, 4];

					return <Text key={item.key} style={{
						fontWeight: (item.style & bold) ? 'bold' : null,
						fontStyle: (item.style & italic) ? 'italic' : null,
						textDecorationLine: (item.style & underline) ? 'underline' : null,
					}}>{item.text}</Text>
				})
			}
		</Text>
	)
}

const Header = ({text, ranges, textStyle}) => (
	<Text style={[styles.header, textStyle]}>
		<StyledText text={text} ranges={ranges} textStyle={[textStyle, { fontSize: textStyle.fontSize + 8 }]}/>
	</Text>
);

const Bullet = ({text, ranges, style, textStyle}) => (
	<View style={[styles.bulletContainer, style]}>
		<View style={[styles.bulletPoint, { backgroundColor: textStyle.color }]}/>
		<StyledText text={text} ranges={ranges} textStyle={textStyle}/>
	</View>
);

const styles = StyleSheet.create({
	header: {
		fontSize: 28,
		fontWeight: 'bold',
		margin: 20,
		marginLeft: 0,
	},
	bulletContainer: {
		marginLeft: 18,
		flexDirection: 'row',
		alignItems: 'center',
	},
	bulletPoint: {
		width: 6,
		height: 6,
		borderRadius: 45,
		backgroundColor: 'black',
		marginRight: 10,
	},
});

RenderBlocks.propTypes = {
    blocks: PropTypes.array.isRequired,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    textStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
